import { render } from "./App.vue?vue&type=template&id=1a2b1d7e&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=1a2b1d7e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\luke\\Desktop\\Bod_registration\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a2b1d7e"]])

export default __exports__